import { useTranslate } from '@refinedev/core';
import { Select, Typography, theme } from 'antd';
import type { SummaryKey } from './summaryQueries';
import { viewQueries } from './summaryQueries';

interface DistributionPeriodViewSelectProps {
  value: SummaryKey | null;
  onChange: (key: SummaryKey | null) => void;
}

/** `Widok: <view>` — which predefined filter set the table shows. */
export const DistributionPeriodViewSelect = ({
  value,
  onChange,
}: DistributionPeriodViewSelectProps) => {
  const t = useTranslate();
  const { token } = theme.useToken();
  const label = (key: SummaryKey) =>
    t(`content_catalog.distribution_periods.views.${key}`);

  return (
    <Select<SummaryKey>
      value={value ?? 'all'}
      onChange={(key) => onChange(key === 'all' ? null : key)}
      prefix={
        <Typography.Text type="secondary">
          {t('content_catalog.distribution_periods.views.label')}
        </Typography.Text>
      }
      popupMatchSelectWidth={false}
      style={{ minWidth: 220, fontWeight: token.fontWeightStrong }}
      options={viewQueries().map((v) => ({
        value: v.key,
        label: label(v.key),
      }))}
    />
  );
};
